import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import ActionNotifications from "../../Components/ActionNotifications";
import Input from "../../Components/Input";
import atlasLogo from "../../Assets/images/AtlasLogo-white.png";
import useFetch from "../../Hooks/useFetch";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function FirstTimeUserPage() {
  const navigate = useNavigate(),
    fetch = useFetch(navigate),
    userStr = localStorage.getItem("user"),
    userInfo = JSON.parse(userStr),
    [state, setState] = useState({
      newPassword: "",
      oldPassword: "",
      newPasswordError: false,
      oldPasswordError: false,
      email: "",
      name: "",
      showSpinner: false,
      notifications: [],
    });

  const onLoginInInputChange = async (e) => {
    const { name, value } = e.target;
    const inputNameError = `${name}Error`;
    let stateValues = { ...state };

    stateValues = { ...stateValues, [name]: value };

    if (name !== "") {
      stateValues = { ...stateValues, [inputNameError]: false };
    }

    setState(stateValues);
  };

  const onChangepasswordclick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let stateValues = { ...state };

    if (state.newPasswordError || state.oldPasswordError) {
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Please fix all error(s) before submitting.",
      });
    }

    if (stateValues.oldPassword === "") {
      stateValues = { ...stateValues, oldPasswordError: true };
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Old password is required.",
      });
    }

    if (stateValues.newPassword === "") {
      stateValues = { ...stateValues, newPasswordError: true };
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "New password is required.",
      });
    }

    setState(stateValues);

    if (!stateValues.newPasswordError && !stateValues.oldPasswordError) {
      setState({ ...state, showSpinner: true });
      const body = {
        Email: state.email,
        NewPassword: state.newPassword,
        OldPassword: state.oldPassword,
      };

      const response = await fetch.post(
        `${apiBaseURL}/api/users/ChangePassword`,
        body
      );
      console.log(response);
      if (response.success) {
        if (response.data.statusCode) {
          if (userInfo) {
            userInfo["new"] = false;
            localStorage.setItem("user", JSON.stringify(userInfo));
            navigate("/");
            window.location.reload();
          } else {
            let notifications = null;

            if (Array.isArray(response.data.messeges)) {
              notifications = response.data.messeges.map((message) => ({
                isMessageInGDStanding: false,
                message,
              }));
            } else {
              notifications = [
                {
                  isMessageInGDStanding: false,
                  message:
                    "An error has occurred. Please try again, and if the problem persists, contact the ATLAS software team.",
                },
              ];
            }

            setState({
              ...state,
              showSpinner: false,
              notifications: [].concat(state.notifications, notifications),
            });
          }
        } else {
          let notifications = response.data.messeges.map((message) => ({
            isMessageInGDStanding: false,
            message,
          }));

          setState({
            ...state,
            showSpinner: false,
            notifications: [].concat(state.notifications, notifications),
          });
        }
      } else {
        let notifications = null;

        if (Array.isArray(response.errors)) {
          notifications = response.errors
            ? response.errors
            : [
                {
                  isMessageInGDStanding: false,
                  message: "An error has occured. Please try again later.",
                },
              ];
        } else {
          notifications = [
            {
              isMessageInGDStanding: false,
              message:
                "An error has occurred. Please try again, and if the problem persists, contact the ATLAS software team.",
            },
          ];
        }

        setState({
          ...state,
          showSpinner: false,
          notifications: [].concat(state.notifications, notifications),
        });
      }
    }
  };

  useEffect(() => {
    if (userInfo) {
      setState({
        ...state,
        email: userInfo?.email,
        name: userInfo?.name,
      });
    } else {
      window.location.reload();
    }
  }, []);

  return (
    <div id="LoginPage" className="inner ">
      <div id="FirstTimeUserPage" className="mt-5 pt-5 px-3">
        <ActionNotifications arrayOfToasts={state.notifications} />
        <div className="boxCotainerWrapper text-center container whiteBG mt-md-5">
          <div className="row g-0">
            <div className="col-12 mb-3">
              <img alt="Atlas Logo" src={atlasLogo} width="125" />
            </div>
            <div className="row g-0">
              <div className="col-12 mb-3">
                <h1>Welcome, {state.name}.</h1>
                <h4 className="darkGray noBold">
                  Please change your password below.
                </h4>
              </div>
            </div>
            <div className="row g-0">
              <form onSubmit={onChangepasswordclick}>
                <Input
                  isError={state.oldPasswordError}
                  name="oldPassword"
                  onChange={onLoginInInputChange}
                  value={state.oldPassword}
                  labelTitle="Current Password"
                  type="password"
                />
                <Input
                  isError={state.newPasswordError}
                  name="newPassword"
                  onChange={onLoginInInputChange}
                  value={state.newPassword}
                  labelTitle="New Password"
                  type="password"
                />
                <button type="submit" className="col-12 button yellowBG my-3">
                  {state.showSpinner ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      className="fa-spin"
                      size="lg"
                    />
                  ) : (
                    "Change Password"
                  )}
                </button>
              </form>
              {/*<button onClick={() => { userInfo['new'] = false; localStorage.setItem('user', JSON.stringify(userInfo)); }}>Not New User</button>
                        <button onClick={() => { localStorage.removeItem('user'); localStorage.removeItem('token'); }}>Log out</button>
                        <button onClick={() => navigate('/Dashboard')}>Dashboard Page</button>
                        <button onClick={() => navigate('/login')}>Login Page</button>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
